import Joint from './Joint'
import Single from './Single'
export default {Joint, Single}



// WEBPACK FOOTER //
// ./src/apps/Payment/index.js